<template>
    <div class="newsListModel">
         <!-- 头部导航公共组件 -->
         <Header :iseNavigat="isChildeNavigat" :isScroll="isScroll" :isMobile="isMobile"></Header>
         
         <!-- 主体内容 -->
         <section class="project-content-model">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6" v-for="(item, index) in ProjectList" :key="index">
                    <div class="project-section" @click="handelDetail(item.proid,item.utype,item.mousefileurl,item.pwdstr,item.tempwdstr,item.uflag,index)" :ref="index === 0 ? 'projectCol' : null">
                        <div class="project-img" :style="{height : projectColHeight + 'px'}" v-if="item.utype != 3 && item.utype != 4">
                            <img class="main-image" :src="item.fileurl" @contextmenu.prevent>
                            <img class="secondary-image" :src="item.mousefileurl" @contextmenu.prevent>

                            <!-- 普通访问 直接展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                                
                            </div>

                            <!-- 受邀访问 点击展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                                
                            </div>

                            <!-- vip是否登录提示 -->
                            <!-- <div :class="['vip-model',isVipShow ? 'vipshowmodel' : '']" v-if="item.uflag == 1">
                                <p style="font-size: 1rem;font-family: 'ahronbd';padding: 24px 0 0px 0;">Permission Denied</p>
                                <p style="font-size: 0.75rem;padding-top: 0;">受限访问</p>
                            </div> -->
                        </div>
                        <div class="project-img-move" :style="{height : projectColHeight + 'px'}" v-else>
                            <img class="main-image" :src="item.fileurl">
                            <img class="videoIcomPlay" src="../assets/images/playIcon.png"/>

                            <!-- 普通访问 直接展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                                
                            </div>

                            <!-- 受邀访问 点击展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                                
                            </div>


                            <!-- vip是否登录提示 -->
                            <!-- <div :class="['vip-model',isVipShow ? 'vipshowmodel' : '']" v-if="item.uflag == 1">
                                <p style="font-size: 1rem;font-family: 'ahronbd';padding: 24px 0 0px 0;">Permission Denied</p>
                                <p style="font-size: 0.75rem;padding-top: 0;">受限访问</p>
                            </div> -->

                        </div>
                        <div class="project-model-box">
                            <div class="project-name-box">
                                <p>{{ item.introstr }}</p>
                                <h5 :title="item.proname" v-if="item.utype != 3 && item.utype != 4">{{ item.proname }}</h5>
                                <h5 :title="item.proname" v-else style="font-family: Arial;font-size: 24px;font-weight: 500;">{{ item.proname }}</h5>
                            </div>
                            <div :class="['project-time-box', isMobile ? 'mobileProjectTime' : '']">
                                <div :class="[isMobile ? 'mobileTime' : '']" style="margin-bottom: 5px;text-align: right;">{{ item.projectctime }}</div>
                                <div style="display: flex;align-items: center;">
                                    <span style="display: flex;align-items: center;font-weight: 500;width: 100%;justify-content: flex-start;"><img :class="[isMobile ? 'yanMobileSize' : 'yanSize']" src="../assets/images/yan.png"/> <span :class="[isMobile ? 'mobileView' : '']">{{ item.bornum }}</span></span>
                                
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </el-col>
               
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                    <div class="project-section" @click="handelDetail(0)">
                        <div class="project-img">
                        <img class="main-image" src="../assets/images/product_img_1.png">
                        <img class="secondary-image" src="../assets/images/product_img_3.png">
                        </div>
                        <h5>宁波中心</h5>
                        <p>NINGBO CENTRE TOWER</p>
                    </div>
                </el-col> -->
            </el-row>
         </section>


         <!-- 视频播放 -->
        <div class="Image-Preview-full-box" v-if="isFullVideo" ref="fullVideoModel">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" @click="handelVideoviewClose">
                <img src="../assets/images/close-white.png" />
            </div>
            <video controls ref="videoFullPlayer" @play="handlePlay" @click="hanldeFullPalayVideo" :src="FullVideoUrl" controlslist="nodownload nofullscreen"></video>
            <div style="position: absolute;width: 80px;left: 50%;top: 50%;transform: translate(-50%, -50%);"><img style="width: 100%;" src='../assets/images/playIcon.png' v-if="!isvideoFullPlayer" @click="hanldeFullPalayVideo"></div>
        </div>
         <!-- 尾部导航公共组件 -->
        <Footer></Footer>
        <!-- end -->
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

import screenfull from 'screenfull'

import {getItemList,setPageViewInfo} from '@/api/axios-api'

export default {
    name: 'NewsList',
    components: {
        Header,
        Footer,
        // HelloWorld,
        // loading
    },
    data () {
        return {
            isFullVideo: false,
            isScroll: 3,
            videoHeight: 0,
            isChildeNavigat: true,
            ProjectList: [],
            isNewListDataListCache: true,
            projectColHeight: 0,
            FullVideoUrl: '',
            password: '',
            tempwdstr: '',
            passwordStateIndex: '',
            utypeState: '',
            proid: '',
            mousefileurl: '',
            pwdstr: '',
            placeholderText: 'Decode 解码',
            // isEnter: false,
            isSpanceEnter: false,
            OldDindex: '',
            isPC: false,
            isMobile: false,
            systemLanguage: '', // 获取系统语言
            ipuserflag: false, // 判断游客有没有登录
            isVipShow: false,
            isvideoFullPlayer: true,
            spanceIndex: 0
        }
    },
    created () {
        // 查看有没有登录
        if (sessionStorage.getItem('isVisited') != null) {
            this.ipuserflag = JSON.parse(sessionStorage.getItem('isVisited'))
            // alert(this.ipuserflag)
        } else {
            this.ipuserflag = false
        }

        this.systemLanguage = navigator.language || navigator.userLanguage // navigator.language 更标准，navigator.userLanguage 用于兼容旧浏览器)
        sessionStorage.removeItem('aboutPageScroll')
    },
    beforeDestroy() {
         window.removeEventListener('keyup', this.JumpDetails) // 按回车键密码
    },
    mounted () {

        const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        if (userAgent) {
            this.isMobile = true
            } else {
            this.isPC = true
        
        }

        document.body.style.overflow = 'auto'
        
        if (sessionStorage.getItem('isNewListDataListCache') == null) {
           this.getItemListFun()
          
        } else {
          
            this.ProjectList = JSON.parse(sessionStorage.getItem('NewListData'))
        }

        this.$nextTick(() => {
            this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
        })

        window.onresize = () => {
            this.$nextTick(() => {
                this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
            })
        }

        window.addEventListener('keyup', this.JumpDetails) // 按回车键监听输入密码跳转详情页
        
    },

    methods: {
        handlePlay () {
            // sessionStorage.setItem('oldProjectScrollTop',sessionStorage.getItem('oldProjectScrollTop'))
            if (!this.isvideoFullPlayer) {
                screenfull.toggle(this.$refs.fullscreenElement)
            }
            this.isvideoFullPlayer = true

        },

        hanldeFullPalayVideo () {

            if (this.$refs.videoFullPlayer.paused) { // 检查视频是否暂停，如果是则播放
                this.$refs.videoFullPlayer.play()
                this.isvideoFullPlayer = true
                
                screenfull.toggle(this.$refs.fullscreenElement)
                
            } else { // 如果视频正在播放，则暂停（可选）
                this.$refs.videoFullPlayer.pause()
                this.isvideoFullPlayer = false
            }
        
        },

        handelDetail (proid,utype,mousefileurl,pwdstr,tempwdstr,uflag,index) {
            // proid
            this.password = ''
            this.isEnter = false
            this.isSpanceEnter = false
            sessionStorage.setItem('oldProjectScrollTop',window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0)

            if (this.OldDindex != index) {
                this.placeholderText = 'Decode 解码'
            }
            this.OldDindex = index

            if (uflag == 1) {
                // 直接访问
                const parseInfo = {}
                parseInfo.proid = proid
                setPageViewInfo(parseInfo).then(res => {
                    console.log(res)
                })
                if (utype == 3 || utype == 4) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.$refs.videoFullPlayer.play();
                        }, 2000); // 2秒后自动播放视频
                    })
                    this.FullVideoUrl = mousefileurl
                    this.isFullVideo = true
                    document.body.style.overflow = 'hidden'
                    // this.toggleFullScreen()
                    screenfull.toggle(this.$refs.fullscreenElement)
                    this.isvideoFullPlayer = true

                    if (screenfull.enabled) {
                    
                    screenfull.on('change', () => {
                        if (!screenfull.isFullscreen) {
                        this.isvideoFullPlayer = false
                        this.$refs.videoFullPlayer.pause()
                        }
                    })
                    } else {
                        alert('全屏API不被支持');
                    }


                } else {
                    this.$router.push({
                        path: '/newsDetail',
                        query: {proid: proid}
                    })
                }
            } else if (uflag == 2) {
                // 密码访问
                this.passwordStateIndex = index
                this.proid = proid
                this.pwdstr = pwdstr
                this.tempwdstr = tempwdstr
                this.mousefileurl = mousefileurl
                this.utypeState = utype
                // window.addEventListener('keyup', this.JumpDetails) // 按回车键密码
            }
            // if (uflag == 1) {
            //     if (!this.ipuserflag) {
            //         this.isVipShow = true
            //         setTimeout(() => {
            //             this.isVipShow = false // 延迟显示所有div，可以根据需要调整延迟时间
            //         }, 3000); // 例如，延迟1秒显示所有div
            //     } else {
            //         if (pwdstr == '') {
            //             const parseInfo = {}
            //             parseInfo.proid = proid
            //             setPageViewInfo(parseInfo).then(res => {
            //                 console.log(res)
            //             })
            //             if (utype == 3 || utype == 4) {
            //                 this.$nextTick(() => {
            //                     setTimeout(() => {
            //                         this.$refs.videoFullPlayer.play();
            //                     }, 2000); // 2秒后自动播放视频
            //                 })
            //                 this.FullVideoUrl = mousefileurl
            //                 this.isFullVideo = true
            //                 document.body.style.overflow = 'hidden'
            //                 // this.toggleFullScreen()
            //                 screenfull.toggle(this.$refs.fullscreenElement)
            //                 this.isvideoFullPlayer = true

            //                 if (screenfull.enabled) {
                            
            //                 screenfull.on('change', () => {
            //                     if (!screenfull.isFullscreen) {
            //                     this.isvideoFullPlayer = false
            //                     this.$refs.videoFullPlayer.pause()
            //                     }
            //                 })
            //                 } else {
            //                     alert('全屏API不被支持');
            //                 }


            //             } else {
            //                 this.$router.push({
            //                     path: '/newsDetail',
            //                     query: {proid: proid}
            //                 })
            //             }
            //         } else {
            //             this.passwordStateIndex = index
            //             this.proid = proid
            //             this.pwdstr = pwdstr
            //             this.tempwdstr = tempwdstr
            //             this.mousefileurl = mousefileurl
            //             this.utypeState = utype
            //             window.addEventListener('keyup', this.JumpDetails) // 按回车键密码
            //         }
            //     }
            // } else if (uflag == 2) {
            //     if (pwdstr == '') {
            //         const parseInfo = {}
            //         parseInfo.proid = proid
            //         setPageViewInfo(parseInfo).then(res => {
            //             console.log(res)
            //         })
            //         if (utype == 3 || utype == 4) {
            //             this.$nextTick(() => {
            //                 setTimeout(() => {
            //                     this.$refs.videoFullPlayer.play();
            //                 }, 2000); // 2秒后自动播放视频
            //             })
            //             this.FullVideoUrl = mousefileurl
            //             this.isFullVideo = true
            //             document.body.style.overflow = 'hidden'
            //             // this.toggleFullScreen()
            //             screenfull.toggle(this.$refs.fullscreenElement)
            //             this.isvideoFullPlayer = true

            //             if (screenfull.enabled) {
                        
            //             screenfull.on('change', () => {
            //                 if (!screenfull.isFullscreen) {
            //                 this.isvideoFullPlayer = false
            //                 this.$refs.videoFullPlayer.pause()
            //                 }
            //             })
            //             } else {
            //                 alert('全屏API不被支持');
            //             }
            //         } else {
            //             this.$router.push({
            //                 path: '/newsDetail',
            //                 query: {proid: proid}
            //             })
            //         }
            //     } else {
            //         this.passwordStateIndex = index
            //         this.proid = proid
            //         this.pwdstr = pwdstr
            //         this.tempwdstr = tempwdstr
            //         this.mousefileurl = mousefileurl
            //         this.utypeState = utype
            //         window.addEventListener('keyup', this.JumpDetails) // 按回车键密码
            //     }
            // }

            
           
            
        },

        JumpDetails(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                // alert(this.password)
                // const parseInfo = {}
                // parseInfo.pwdstr = this.password
                // parseInfo.
                // getProjectDetail
                if (this.password == this.pwdstr || this.tempwdstr == this.tempwdstr) {
                    this.setJumpDetailsFun(this.proid,this.mousefileurl,this.password)
                    this.password = ''
                    this.placeholderText = 'Decode 解码'
                } else {
                    // this.password = ''
                    // this.isEnter = false
                    // this.isSpanceEnter = false
                    // this.placeholderText = '密码错误'
                    this.ProjectList[this.spanceIndex].password = ''
                    this.ProjectList[this.spanceIndex].placeholderText = '密码错误'
                    // this.isEnter = false
                    this.isSpanceEnter = false

                    setTimeout(() => {
                        this.ProjectList[this.spanceIndex].placeholderText = 'Decode 解码'
                    },1500)

                }
                
                // console.log('全局回车键被按下');
                // this.handleWebsite()
                // 添加你的逻辑
            }
        },

        setJumpDetailsFun (proid,mousefileurl,password) {
            const parseInfo = {}
            parseInfo.proid = proid
            setPageViewInfo(parseInfo).then(res => {
                console.log(res)
            })
            if (this.utypeState == 3 || this.utypeState == 4) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.videoFullPlayer.play();
                    }, 2000); // 2秒后自动播放视频
                })
                this.FullVideoUrl = mousefileurl
                this.isFullVideo = true
                document.body.style.overflow = 'hidden'
                // this.toggleFullScreen()
                screenfull.toggle(this.$refs.fullscreenElement)
                this.isvideoFullPlayer = true

                if (screenfull.enabled) {
                  
                  screenfull.on('change', () => {
                      if (!screenfull.isFullscreen) {
                      this.isvideoFullPlayer = false
                      this.$refs.videoFullPlayer.pause()
                      }
                  })
                } else {
                  alert('全屏API不被支持');
                }

            } else {
                this.$router.push({
                    path: '/newsDetail',
                    query: {proid: proid,pwdstr: password}
                })
            }
        },

        // 监听input 输入
        handlePasswordInpt (event,index,pwdstr,tempwdstr) {

            this.password = event
            this.spanceIndex = index
            this.pwdstr = pwdstr
            this.tempwdstr = tempwdstr

            // const value = event.target.value
            if (this.password === '') {
                this.isSpanceEnter = false
            } else {
                this.isSpanceEnter = true
            }
            
            // if (event === this.pwdstr || event.toLowerCase() === this.tempwdstr.toLowerCase()) {
            //     setTimeout(() => {
            //         this.setJumpDetailsFun(this.proid,this.mousefileurl,this.password)
            //         this.password = ''
            //         this.placeholderText = ''
            //     },100)
            
            // } else if ((event != this.pwdstr || event.toLowerCase() != this.tempwdstr.toLowerCase()) && event.length == 4) {
            //     if (this.systemLanguage == 'zh-CN') {
            //         this.placeholderText = '密码错误'
            //     } else {
            //         this.placeholderText = 'Invalid Password'
            //     }
            //     this.password = ''
            //     this.isSpanceEnter = false

            //     setTimeout(() => {
            //         this.placeholderText = ''
            //     },2000)
            // }
        },

        // handleJumpPasswor () {
        //     if (this.password == this.pwdstr) {
        //         this.setJumpDetailsFun(this.proid,this.mousefileurl,this.password)
        //         this.password = ''
        //         this.placeholderText = 'Decode 解码'
        //     } else {
        //         this.isEnter = false
        //         this.isSpanceEnter = false
        //         this.password = ''
        //         this.placeholderText = '密码错误'
        //     }
        // },

        handelVideoviewClose () {
            document.body.style.overflow = 'auto'
            window.scrollTo({
                top: sessionStorage.getItem('oldProjectScrollTop'),
                behavior: 'smooth'
            })
            this.isvideoFullPlayer = true
            this.isFullVideo = false
            this.FullVideoUrl = ''
            // document.body.style.overflow = 'auto'
            document.exitFullscreen()
        },

        toggleFullScreen() {

            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
                })
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                }
            }
        },

        getItemListFun () {
            const parseInfo = {}
            parseInfo.utype = 2 // 1项目，2新闻
            getItemList(parseInfo).then(res => {
                // console.log(res)
                if (res.code == 0) {

                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                        
                    }
                    this.ProjectList = res.map.list

                    this.$nextTick(() => {
                        this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
                    })

                    sessionStorage.setItem('isNewListDataListCache', this.isProjectListCache)
                    sessionStorage.setItem('NewListData', JSON.stringify(this.ProjectList))
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.newsListModel .project-content-model {
    padding: 120px 30px 2px 30px;
}
.newsListModel .project-content-model .project-section {
//   margin-bottom: 2.5vw;
margin-bottom: 35px;
//   text-align: center;
  font-family: "SourceHanSans";
  cursor: pointer;
}
.newsListModel .project-img {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
}

.newsListModel .project-img .main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}

.newsListModel .project-img-move {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
}
.newsListModel .project-img-move .main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}
.newsListModel .videoIcomPlay {
  position: absolute;
  width: 55px;
  left: 50%;
  top: 50%;
  // color: #f7f7f7;
  transform: translate(-50%, -50%);
}

.newsListModel .project-img .secondary-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  opacity: 0; /* 默认隐藏 */
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}
.newsListModel .project-img:hover .main-image {
  opacity: 0;
}
.newsListModel .project-img:hover .secondary-image {
  opacity: 1;
}
.newsListModel .project-content-model .project-section h5 {
  font-size: 1.125rem;
  font-weight: 700;
  font-family: "SourceHanSans";
  white-space: break-spaces;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 限制行数为2 */
  overflow: hidden;
//   white-space: nowrap; /* 防止文本换行 */
//   overflow: hidden; /* 隐藏超出容器的部分 */
//   text-overflow: ellipsis; /* 显示省略号 */
//   padding-bottom: 7px;
}
.newsListModel .project-content-model .project-section p {
//   height: 36px;
//   line-height: 20px;
  font-size: 1.25rem;
  padding: 12px 0 0px 0;
  font-family: "ahronbd";
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.newsListModel .project-model-box {
  display: flex;
  justify-content: space-between;
  height: 4.375rem;
}
.newsListModel .project-name-box {
  width: 70%;
}
.newsListModel .project-time-box {
  font-size: 0.875rem;
  font-family: Arial;
  padding: 1rem 0 0 0;
  font-weight: 700;
//   width: 72px;
}
.newsListModel .Image-Preview-full-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    z-index: 999;
}
.newsListModel .Image-Preview-full-box video {
    width: 100%;
    height: 100%;
    // object-fit: cover;
}
.newsListModel::v-deep .passwordInpt {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 150px;
  margin-left: -75px;
  // top: 65%;
  margin-top: -16px;
  background-color: #000;
  border-radius: 16px;
  
}
.newsListModel::v-deep .passwordInpt .el-input__inner {
  background-color: #000;
  border: 1px solid #000;
  border-radius: 17px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-family: "SourceHanSans";
//   letter-spacing: 3px;
}
.newsListModel::v-deep .passwordInptSpance .el-input__inner{
    letter-spacing: 5px;
    // font-size: 7px;
    font-size: 25px;
    font-family: '微软雅黑';
    height: 32px;
    line-height: 32px;
}

.newsListModel::v-deep .passwordInptMobileSpance .el-input__inner{
    letter-spacing: 5px;
    font-size: 10px;
    // font-size: 25px;
    // font-family: '微软雅黑';
    height: 32px;
    line-height: 32px;
}

.newsListModel .mobileProjectTime {
  padding: 13px 0 0 0;
  // color: RED;
}
.newsListModel .project-time-box .yanSize {
  width: 19px;
  margin-right: 5px;
}
.newsListModel .project-time-box .yanMobileSize {
  width: 14px;
  margin-right: 5px;
}
.newsListModel .project-time-box .mobileTime {
  font-size: 11px;
  // color: red;
}
.newsListModel .project-time-box .mobileView {
  font-size: 12px;
}

.newsListModel .vip-model {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  transform: translateY(100%); /* 向上移动的距离 */
  background: rgba(0,0,0,0.5);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s ease; /* 添加过渡效果 */
  
}
// .CTG-mian-content .vip-model P {
//   font-size: 1rem!important;
// }
.newsListModel .vipshowmodel {
  transform: translateY(0); /* 向上移动的距离 */
}
</style>